import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { ContendientesService } from 'src/app/services/contendientes.service';

@Component({
  selector: 'app-navbar',
  templateUrl: './navbar.component.html',
  styleUrls: ['./navbar.component.css'],
})
export class NavbarComponent implements OnInit {
  public today: any;
  fullTextString: any;
  loadingPosts: boolean = true;
  keyWord: any;
  contendientes: any;
  catalog: any;
  files: any;
  constructor(private api: ContendientesService, private router: Router) {}

  ngOnInit(): void {
    this.today = this.formatAMPM();
  }
  buscarContendiente(termino: string) {
    // console.log('termino');
    // console.log(termino);
    this.router.navigate(['/buscador', termino]);
  }
  searchPosts(termino: string) {
    const keyWordFilter = this.fullTextString ? null : this.keyWord;
    this.loadingPosts = true;
    this.api
      .searchPosts(keyWordFilter, this.fullTextString, this.files, this.catalog)
      .refetch()
      .then((result) => {
        this.loadingPosts = false;
        return result.data && result.data.filter;
      });
  }
  formatAMPM(): string {
    const d = new Date();
    const months = [
      'de enero',
      'de febrero',
      'de marzo',
      'de abril',
      'de mayo',
      'de junio',
      'de julio',
      'de agosto',
      'de septiembre',
      'de octubre',
      'de noviembre',
      'de diciembre',
    ];
    const days = [
      'Domingo',
      'Lunes',
      'Martes',
      'Miércoles',
      'Jueves',
      'Viernes',
      'Sábado',
    ];
    return (
      days[d.getDay()] +
      ' ' +
      d.getDate() +
      ' ' +
      months[d.getMonth()] +
      ' , ' +
      d.getFullYear()
    );
  }
}
